import { CategoriaNoticiasGeneralesPage } from './../pages/categoria-noticias-generales/categoria-noticias-generales';
import { ContactoPage } from './../pages/contacto/contacto';
import { BuscadorPage } from './../pages/buscador/buscador';
import { Component, ViewChild } from '@angular/core';
import { Platform, MenuController, Nav, ModalController } from 'ionic-angular';
import { ListaPueblosPage } from '../pages/lista-pueblos/lista-pueblos';
import { TelefonosGeneralesPage } from '../pages/telefonos-generales/telefonos-generales';
import { MapaProvinciasPage } from '../pages/mapa-provincias/mapa-provincias';
import { ListaProvinciasPage } from '../pages/lista-provincias/lista-provincias';
import { QuieneSomosPage } from '../pages/quienes-somos/quienes-somos';
import { ComoAnunciartePage } from '../pages/como-anunciarte/como-anunciarte';


@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage = ListaProvinciasPage;
  pages: Array<{title: string, component: any,icon:string,parametro:any}>;


  constructor(
    public platform: Platform,
    public menu: MenuController,
    public modalCtrl: ModalController,
  ) {
    this.initializeApp();

    // set our app's pages
    this.pages = [
      { title: 'Inicio', component: ListaProvinciasPage, icon:'home',parametro:null },
      { title: 'Telefonos Generales', component: TelefonosGeneralesPage, icon:'call',parametro:null },
      { title: 'Quienes Somos', component: QuieneSomosPage, icon:'contacts',parametro:null },
      { title: 'Como anunciarte', component: ComoAnunciartePage, icon:'information-circle',parametro:null },
      { title: 'Contacto', component: ContactoPage, icon:'contact',parametro:null },

    ];
  }

  initializeApp() {
    (<any>window).gtag('set','page','Pagina inicio');
    (<any>window).gtag('send','pageview');
  }

  openPage(page) {
    // close the menu when clicking a link from the menu
    this.menu.close();
    // navigate to the new page if it is not the current page
    this.nav.push(page.component,{parametro:page.parametro});
  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts